import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import { Button } from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import GroupAddIcon from "@material-ui/icons/GroupAdd";

import InternalChatsList from "../InternalChatsList";
import InternalChatModal from "../InternalChatModal";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    background: theme.palette.background.paper,
    padding: theme.spacing(1),
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
  searchInputWrapper: {
    flex: 1,
    minWidth: 120,
    background: theme.palette.background.default,
    display: "flex",
    borderRadius: 40,
    padding: 4,
    marginRight: theme.spacing(1),
  },
  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },
  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
    color: theme.palette.text.primary,
    backgroundColor: "transparent",
  },
  buttonsRow: {
    display: "flex",
    gap: theme.spacing(1),
    flexShrink: 0,
  },
}));

const InternalChatsManager = () => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const [searchParam, setSearchParam] = useState("");
  const [dmModalOpen, setDmModalOpen] = useState(false);
  const [groupModalOpen, setGroupModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  let searchTimeout;
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => setSearchParam(value), 400);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <InternalChatModal
        type="dm"
        open={dmModalOpen}
        onClose={() => setDmModalOpen(false)}
        user={user}
      />
      <InternalChatModal
        type="group"
        open={groupModalOpen}
        onClose={() => setGroupModalOpen(false)}
        user={user}
      />
      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <div className={classes.searchInputWrapper}>
          <SearchIcon className={classes.searchIcon} />
          <InputBase
            className={classes.searchInput}
            placeholder={i18n.t("internalChat.searchPlaceholder")}
            type="search"
            onChange={handleSearch}
          />
        </div>
        <div className={classes.buttonsRow}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<PersonAddIcon />}
            onClick={() => setDmModalOpen(true)}
          >
            {i18n.t("internalChat.buttons.newDM")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<GroupAddIcon />}
            onClick={() => setGroupModalOpen(true)}
          >
            {i18n.t("internalChat.buttons.newGroup")}
          </Button>
        </div>
      </Paper>
      <InternalChatsList searchParam={searchParam} refreshTrigger={refreshTrigger} />
    </Paper>
  );
};

export default InternalChatsManager;
